export { default as WeightChangeIcon } from './component';
